import React, { useEffect } from "react";
import AddEditForm from "../AddEditForm/View";
import { useParams } from "react-router-dom";

const EditSupplier = ({ currentSupplier, actions, brands }) => {
  const { id } = useParams();

  useEffect(() => {
    actions.getSupplierById(id);
  }, []);

  return (
    currentSupplier && (
      <AddEditForm
        isAddSupplier={false}
        supplierState={currentSupplier}
        actions={actions}
        brands={brands}
      />
    )
  );
};

export default EditSupplier;
